import React from 'react';

const ButtonModal = ({ callFunction, buttonName }) => {

  return (
    <button
      name={buttonName}
      className="btn btn-secondary"
      type="submit"
      onClick={callFunction}
    >
      {' '}
      {buttonName}
      {' '}
    </button>
  );
};

export default ButtonModal;
